import React from "react";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import SnackbarAlert from "../components/SnackbarAlert";
import DialogExportar from "../components/DialogExportar";
import ListaTags from "../components/ListaTags";
import {avanceResources} from "../endpoints";

class DetalleOperador extends React.Component{
    constructor(props) {
        super(props);
        this.state ={
            nombre_operador: "",
            operador: props.match.params.operador,
            severity: '',
            openSnack: false,
            message:'',
            open:false,
            tipo:'detalle_operador',
            columnas : [
                { title: 'Tag', field: 'id' },
                { title: 'Cant. Capt.', field: 'cantidad',
                    render: (rowData => new Intl.NumberFormat("de-DE").format(rowData.cantidad)),
                    customFilterAndSearch: ((term, rowData) => new Intl.NumberFormat("de-DE").format(rowData.cantidad).indexOf(term) !== -1)},
                { title: 'Cant. Fin', field: 'cantidad_umb',
                    render : (rowData => new Intl.NumberFormat("de-DE").format(rowData.cantidad_umb)),
                    customFilterAndSearch: ((term, rowData) => new Intl.NumberFormat("de-DE").format(rowData.cantidad_umb).indexOf(term) !== -1)},
            ]
        }
    }

    handleClose = () =>{
        this.setState({open:false})
    }

    getTagsOperador = ()=>{
        avanceResources.getTagsOperador(this.state.operador).then(async response => {
            if (response) {
                return await response.json();
            }
        }).then(result => {
            if(result.status_code === 200){
                this.setState({datos:result.tags})
            }
            else if (result.status_code === 401){
                this.setState({openSnack:true, severity:result.severity, message:result.message})
            }
            else{
                throw new Error('Something went wrong ...');
            }
        }).catch(error=> {
            console.log(error)
        });
    }

    refrescar =(estado,severity) =>{
        this.setState({ open: false, openSnack: false})
        if (severity){
            this.setState({
                open: false,
                openSnack: true,
                message: estado,
                severity: severity
            })
        }
    }

    componentDidMount() {
        this.getTagsOperador()
    }

    render() {
        return(
            <div>
                <Grid container>
                    <Grid item>
                        <Typography variant="h4" gutterBottom>Detalle operador: {this.state.operador} {this.state.nombre_operador}</Typography>
                    </Grid>

                </Grid>
                <br/>
                <ListaTags id_ubicacion={this.state.idUbicacion} datos={this.state.datos} columnas={this.state.columnas} tipo={this.state.tipo} refrescarTags={this.refrescarTagsUbicacion}/>
                {this.state.openSnack? <SnackbarAlert severity={this.state.severity} message={this.state.message}/> : null}
                {this.state.open? <DialogExportar reporte={this.state.reporte} origen={'otro'} params={this.state.params} refrescar={this.refrescar} handleClose={this.handleClose}/> : null}
            </div>
        )
    }
}

export default DetalleOperador;